import { render } from "./BookingsProfitReportList.vue?vue&type=template&id=67b6247c"
import script from "./BookingsProfitReportList.vue?vue&type=script&lang=js"
export * from "./BookingsProfitReportList.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__